import { connect } from 'react-redux';
import Song from '../components/Song';

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  song: state.song,
  ui: state.ui,
});

const mapDispatchToProps = dispatch => ({});

const SongContainer = connect(mapStateToProps, mapDispatchToProps)(Song);

export default SongContainer;



// WEBPACK FOOTER //
// ./src/containers/SongContainer.js